<template>
  <v-btn icon color="on-primary" @click="onClick" class="wgu-action-button"
    :title="$t('wgu-infobutton.title')">
    <v-icon size="large" color="on-primary">{{icon}}</v-icon>
  </v-btn>
</template>

<script>

import { WguEventBus } from '../../../src/WguEventBus'

export default {
  name: 'wgu-infobutton-btn',
  props: {
    icon: { type: String, required: false, default: 'zoom_out_map' }
  },
  created () {
    WguEventBus.$on('infoButton-topicButton', this.changeTopicName);
  },
  data () {
    const urlObj = new URL(window.location.href)

    if (urlObj.searchParams.get('Module')) {
      if (this.$appConfig.TopicList.indexOf(urlObj.searchParams.get('Module')) >= 0) {
        this.$appConfig.TopicDefault = urlObj.searchParams.get('Module')
      }
    }

    return {
      iconSize: 'large',
      topicName: this.$appConfig.TopicDefault,
      infoLinkURL: this.$appConfig.modules['wgu-infobutton'].infoLinkURL
    }
  },
  methods: {
    onClick () {
      /* TODO: anchor mit Topic.okay oder separte Seiten? */
      window.open(this.infoLinkURL.replace('.html', '.' + (this.$i18n.locale ? this.$i18n.locale : this.$i18n.fallbackLocale) + '.html') + '#' + this.topicName, '_blank')
    },
    changeTopicName (t) {
      this.topicName = t;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
